import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { PageHeader } from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'
import { selectSignupWithExternals } from 'internal-components/src/redux/modules/signup/selectors'

import createSignupProgress, {
  SignupProgressRecord,
} from '../../records/SignupProgress'

import PageLoading from '../../components/Layout/PageLoading'
import SignupCompleted from '../../components/Signup/Completed'
import ProgressSummary from '../../components/Signup/ProgressSummary'

export function FinishedView({ loading, signupProgress, signupWithExternals }) {
  return (
    <section className="container">
      <PageHeader>
        {signupWithExternals &&
          signupWithExternals.signup.reference && (
            <small className="pull-right">
              {signupWithExternals.signup.reference}
            </small>
          )}
        Signup Completed
      </PageHeader>

      {signupProgress && (
        <ProgressSummary
          signupProgress={signupProgress}
          signupWithExternals={signupWithExternals}
        />
      )}

      {loading && <PageLoading />}
      {!loading && (
        <SignupCompleted signupWithExternals={signupWithExternals} />
      )}
    </section>
  )
}

FinishedView.propTypes = {
  loading: Pt.bool.isRequired,
  signupProgress: Pt.instanceOf(SignupProgressRecord),
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
}

const mapStateToProps = () => {
  const selectSignupLoading = makeSelectLoading()
  const selectLoading = makeSelectLoading()

  return (state, { params }) => {
    const signupWithExternals = selectSignupWithExternals(state, {
      reference: params.reference,
    })
    const signupProgress = signupWithExternals
      ? createSignupProgress(signupWithExternals, undefined, 'summary')
      : undefined

    return {
      loading:
        selectSignupLoading(state, {
          type: 'signup',
          keys: params.reference,
        }) || selectLoading(state, { type: ['product', 'offers'] }),
      signupProgress,
      signupWithExternals,
    }
  }
}

export default connect(mapStateToProps)(FinishedView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/FinishedView.jsx